import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'add_payment_method_confirmation';
export const route = 'renewal/add_payment_method/confirmation/[shoppingBasketId]/[operationResult]';
export const AddPaymentMethodConfirmationPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "add_payment_method_confirmation" */
/* webpackPrefetch: true */
'../../components/Prime/AddPaymentMethodConfirmationPage')));